import AsyncStorage from '@react-native-async-storage/async-storage';
import { createClient } from '@supabase/supabase-js';
import { Platform } from 'react-native';
import { bindSupabaseClient, supabaseFetchWithAuthRetry } from './supabaseAuthSession';

const supabaseUrl = process.env.EXPO_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    '[Supabase] Faltan variables EXPO_PUBLIC_SUPABASE_URL o EXPO_PUBLIC_SUPABASE_ANON_KEY. Se utilizará un cliente sin conexión real.'
  );
}

/**
 * En algunos navegadores (o perfiles/flags) el LockManager no cumple el spec
 * y @supabase/auth-js emite warnings ruidosos.
 * Este lock no-op evita ese warning y mantiene la sesión funcional en web.
 */
const webNoopAuthLock = async <R,>(_name: string, _acquireTimeout: number, fn: () => Promise<R>) => fn();

export const supabase = createClient(supabaseUrl || 'https://placeholder.supabase.co', supabaseAnonKey || 'public-anon-key', {
  global: {
    fetch: supabaseFetchWithAuthRetry,
  },
  auth: {
    storage: AsyncStorage,
    autoRefreshToken: false,
    persistSession: true,
    detectSessionInUrl: Platform.OS === 'web',
    ...(Platform.OS === 'web' ? { lock: webNoopAuthLock } : {}),
  },
});

bindSupabaseClient(supabase);

export const getSupabaseConfig = () => ({
  url: supabaseUrl || 'https://placeholder.supabase.co',
  anonKey: supabaseAnonKey || 'public-anon-key',
});

export {
  ensureFreshAccessToken,
  refreshSupabaseSessionAndSyncStore,
  isSupabaseJwtExpiredError,
} from './supabaseAuthSession';
